import type { AgentName, AgentStatus as AgentStatusType } from "../../../../shared/types";
import { AgentStatus } from "./AgentStatus";
import { cn } from "../../lib/utils";

interface PipelineStatusProps {
  agentStatus: Record<AgentName, AgentStatusType>;
}

const pipelineSteps: AgentName[] = [
  "intake",
  "ideation",
  "content",
  "repurpose",
];

function ConnectorLine({ status }: { status: AgentStatusType }) {
  return (
    <div className="hidden flex-1 items-center px-1 sm:flex">
      <div
        className={cn(
          "h-0.5 w-full rounded-full",
          status === "ready" && "bg-green-300",
          status === "working" && "bg-blue-300",
          status === "draft" && "bg-amber-300",
          status === "failed" && "bg-red-300",
          status === "queued" && "bg-slate-200",
        )}
      />
    </div>
  );
}

export function PipelineStatus({ agentStatus }: PipelineStatusProps) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="mb-4 text-sm font-semibold text-slate-700">
        Pipeline Progress
      </h3>

      {/* Desktop: horizontal layout */}
      <div className="hidden items-center justify-between sm:flex">
        {pipelineSteps.map((step, i) => (
          <div key={step} className="flex flex-1 items-center">
            <AgentStatus
              name={step}
              status={agentStatus[step] || "queued"}
            />
            {i < pipelineSteps.length - 1 && (
              <ConnectorLine status={agentStatus[step] || "queued"} />
            )}
          </div>
        ))}
      </div>

      {/* Mobile: compact vertical layout */}
      <div className="flex flex-col gap-3 sm:hidden">
        {pipelineSteps.map((step, i) => (
          <div key={step} className="flex items-center gap-3">
            <AgentStatus
              name={step}
              status={agentStatus[step] || "queued"}
            />
            {i < pipelineSteps.length - 1 && (
              <div
                className={cn(
                  "h-4 w-0.5 self-end rounded-full",
                  agentStatus[step] === "ready"
                    ? "bg-green-300"
                    : "bg-slate-200",
                )}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
